<template>
    <v-toolbar  width='1200px' class="toolbarHack213" fixed app>
      
      <a :key="currentProduct" href="https://app.smartpress.co"><img
        
        src="../assets/logo-standalone.png"
        height="30px"
        style="margin:0 10px;"

      /></a>
      <span style="width:120px;text-align:center">SmartPress</span>
      <!-- <span style="width:120px;text-align:center">{{currentProduct}}</span> -->

      <!-- <v-toolbar-title to="/">Smartpress</v-toolbar-title> -->
     <!--  <b-navbar-toggle target="nav_collapse"/> -->
    <!-- <b-navbar-brand to="/">Smartpress</b-navbar-brand> -->
 
      <v-btn v-if="!$vuetify.breakpoint.smAndDown && hasContract" flat style="cursor:pointer;" to="/createContract">Create contract</v-btn>
      <v-btn v-if="!$vuetify.breakpoint.smAndDown"   flat style="text-transform:capitalize;cursor:pointer; margin-left:0px" to="/myContracts">My Contract</v-btn>

      <v-btn v-if="!$vuetify.breakpoint.smAndDown" flat style="text-transform:capitalize;cursor:pointer; margin-left:10px" to="/myUsers">My users</v-btn>

      <v-btn  outline style="text-transform:capitalize;cursor:pointer; margin-left:10px" to="/docs">Documentation</v-btn>

      <v-spacer/>
      <!-- <v-row style="margin-top:10px;">
        <v-col class="d-flex" >
          <v-select
            :items="products"
            :label="currentProduct"
            v-model="currentProductt"
            outlined
            style="max-width:150px;"
          ></v-select>
        </v-col>
      </v-row> -->
 
      <!-- <v-btn v-if="!$vuetify.breakpoint.smAndDown" href="https://t.me/joinchat/IFhXng_pYb-YUMYJw0y-Sg"  target="_blank"  flat    style="background-color:rgba(0,0,0,0.1);text-transform:capitalize;position:relative; margin-right:24px">Telegram support</v-btn> -->
 
    <b-navbar-nav   class="ml-auto">

   
      <b-nav-item 
        v-if="!isAuthenticated" 
        class="nav-btn" 
        to="/signIn"><span class="nav-username">Sign In</span></b-nav-item>
      <b-nav-item-dropdown 
        v-if="isAuthenticated" 
        right>
        <template slot="button-content">
          <icon name="user-circle"/><strong class="nav-username">{{ user.username }}</strong>
        </template>
        <b-row 

          class="justify-content-md-center" 
          >
          <b-dropdown-item style='width:90% !important' to="/billing"><icon name="Billing"/><span>Billing</span></b-dropdown-item>
          <b-dropdown-item style='width:90%' to="/changePassword"><span  >Change Password</span></b-dropdown-item>
          <b-dropdown-item style='width:90%' to="/signOut"><icon name="sign-out"/><span  >Sign Out</span></b-dropdown-item>
        </b-row>
      </b-nav-item-dropdown>
      <!-- <b-nav-item 
        right
        class="nav-btn" 
        @click="toggleDark()"
      > -->
     <!--  <span class="caption" v-if="isDark">Light theme</span> --><!-- <span class="caption" v-else>Dark theme</span> --></b-nav-item>
    </b-navbar-nav>
     <!--  <v-menu
       

      > -->
       <!--  <v-btn
          slot="activator"
          class="purple"
          color="primary"
          dark
        >
          Slide Y Transition
        </v-btn> -->
       <!--  <v-list>
          <v-list-tile
           
          >
            <v-list-tile-title></v-list-tile-title>
          </v-list-tile>
        </v-list> -->
      <!-- </v-menu> -->
    </v-toolbar>
      
    <!-- 

     -->  
</template>

<script>

// Loading bar

  // let loading = {
  //   data () {
  //     return {
  //       value: 0,
  //       query: false,
  //       show: true,
  //       interval: 0,
  //       color: 'blue'
  //     }
  //   },

  //   mounted () {
  //     this.queryAndIndeterminate()
  //   },

  //   beforeDestroy () {
  //     clearInterval(this.interval)
  //   },

  //   methods: {
  //     queryAndIndeterminate () {
  //       this.query = true
  //       this.show = true
  //       this.value = 0

  //       setTimeout(() => {
  //         this.query = false

  //         this.interval = setInterval(() => {
  //           if (this.value === 100) {
  //             clearInterval(this.interval)
  //             this.show = false
  //             return setTimeout(this.queryAndIndeterminate, 2000)
  //           }
  //           this.value += 25
  //           if (this.value === 25) {
  //             this.color = 'warning'
  //           } else if (this.value === 100) {
  //             this.color = 'success'
  //           }
  //         }, 1000)
  //       }, 2500)
  //     }
  //   },
  //   template:
  //     '<div>' +
  //       '<v-progress-linear ' +
  //       'v-model="value" ' +
  //       ':active="show" ' +
  //       ':indeterminate="query" height="20" :color="color"' +
  //       ':query="true"></v-progress-linear>' +
  //     '</div>'
  // }
 
import { mapState } from 'vuex'

import 'vue-awesome/icons/user-circle'
import 'vue-awesome/icons/sign-out'
import 'vue-awesome/icons/github'
import 'vue-awesome/icons/twitter'

export default {
    mounted: function () {
      console.log(this.$router.history)
      if (this.$router.history.current.path == "/smartcheck") {}
    },
    name: 'Navbar',
    data () {
      return {
        currentProductt: '',
        products: ['SmartPress', 'SmartCheck']
      }
    },
    computed: {
      ...mapState({
          user: state => state.auth.user,
          isAuthenticated: state => state.auth.isAuthenticated,
          isDark: state => state.util.isDark,
          myContracts: state => state.contractsDb.myContracts,
          currentProduct: state => state.auth.currentProduct,
          
      }),
      hasContract: function  () {
        if (this.myContracts.Count == 0) {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
        signIn() {
            this.$store.dispatch('signIn')
        },
        toggleDark() {
          this.$store.dispatch('util/toggleDark')
        }
    },
    watch: {
      currentProduct: function () {
        this.currentProduct = this.currentProductt
      },
      currentProductt: function () {
        if (this.currentProductt == 'SmartCheck') {
          this.$store.dispatch('auth/changeProducts', {product: 'SmartCheck'})
          this.$router.push('../../../../../smartcheck')
        } else if (this.currentProductt == 'SmartPress') {
          this.$store.dispatch('auth/changeProducts', {product: 'SmartPress'})
          this.$router.push('../../../../../myContracts/contract')
        }
      }
    }
}
</script>

<style scoped>
.toolbarHack213 {
  box-shadow:none !important;
  -webkit-box-shadow:none !important
}
.navbar-nav .nav-link {
    color: black;
}
.nav-username {
  color: black;
  padding-left: .5em;
  padding-right: .5em;
}
</style>
